"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { useElements } from '../element/useElements.mjs';

function useAppDataSchemas(query) {
  const { ...rest } = useElements("app-data-schemas", query);
  return {
    appDataSchemas: rest.items,
    ...rest
  };
}

export { useAppDataSchemas };
